import React from 'react';
import { Box, Stack, Typography } from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import { CancelButton, DeleteButton } from '../../../components/mui/Buttons/Buttons';
import useHandleApiResponse from '../../../Hooks/useHandleApiResponse';
import { deleteAchievementBadge } from '../../../redux/features/achievementBadgeSlice';

// Soft delete confirmation. Delete is irreversible via the API (no undelete),
// so we confirm before firing.
const DeleteAchievementBadge = ({ row, onClose }) => {
  const dispatch = useDispatch();
  const { mutating } = useSelector((state) => state.achievementBadge);
  const handleApiResponse = useHandleApiResponse();

  const handleDelete = async () => {
    const res = await dispatch(deleteAchievementBadge(row.badge_id));
    handleApiResponse(res, {
      onSuccess: () => {
        if (onClose) onClose(true); // refetch the table
      },
    });
  };

  return (
    <Box sx={{ mt: 1 }}>
      <Typography variant="body1">
        Are you sure you want to delete the badge{' '}
        <strong>{row?.badge_name}</strong>? This cannot be undone.
      </Typography>
      <Box sx={{ display: 'flex', justifyContent: 'flex-end', mt: 3 }}>
        <Stack direction="row" spacing={1}>
          <CancelButton action={() => onClose && onClose(false)}>Cancel</CancelButton>
          <DeleteButton action={handleDelete} disabled={mutating}>
            {mutating ? 'Deleting...' : 'Delete'}
          </DeleteButton>
        </Stack>
      </Box>
    </Box>
  );
};

export default DeleteAchievementBadge;
